<template>
  <div class="slot-panel" style="color:white">
    <div class="line">
      <span class="label">宽:</span>
      <InputNumber placeholder="宽" v-model="slotInfo.position.width" size="small" @on-change="save"></InputNumber>
      <span class="label">高:</span>
      <InputNumber
        placeholder="高"
        v-model="slotInfo.position.height"
        size="small"
        @on-change="save"
      ></InputNumber>
    </div>
    <div class="line">
      <span class="label">X:</span>
      <InputNumber
        placeholder="X"
        v-model="slotInfo.position.translateX"
        size="small"
        @on-change="save"
      ></InputNumber>
      <span class="label">Y:</span>
      <InputNumber
        placeholder="Y"
        v-model="slotInfo.position.translateY"
        size="small"
        @on-change="save"
      ></InputNumber>
    </div>
    <div class="line">
      <span class="label">旋转:</span>
      <InputNumber
        placeholder="Y"
        v-model="slotInfo.position.rotate"
        size="small"
        @on-change="save"
      ></InputNumber>
    </div>
  </div>
</template>
<style lang="less">
    .slot-panel{
        .label{
            display: inline-block;
            width: 30px;
            margin-left: 5px;
        }
        .line{
            margin: 5px 0px;
        }
    }
</style>
<script>
export default {
  props: ["slotInfo"],
  methods: {
    save() {
      this.$emit("save");
    }
  }
};
</script>